import React from "react";
import Axios from 'axios'
import GerenteTemplate from "./GerenteTemplate";
import Cartela from '../_Components/Cartela'
import moment from 'moment';
import API from '../Utils/api'


export class GanhadoresGerente extends React.Component {
    constructor(props) {
        window.localStorage.setItem("rotaAtual", window.location.href.split('/')[3]);
        super(props);
        this.state = {
            user: JSON.parse(localStorage.getItem("user")),
            cartelaSelecionada: null,
            tipoSelecionado: '',
            gabaritos: [],
            clientes: [],
            clienteSelecionado: null,
            form : {nome : "", telefone: "", cidade: "", estado: "" }
        };
        this.selecionarCartela = this.selecionarCartela.bind(this)
        this.listarGanhadores();
    }

    formatDate(data) {
        return moment(data).add(0, 'days').format('DD-MM-YYYY')
    }

    selecionarCartela(e) {
        const gabarito = JSON.parse(e.target.accessKey);
        this.state.tipoSelecionado = gabarito.tipo;
        this.setState({ ...this.state, cartelaSelecionada: gabarito.cartelaSorteada, tipoSelecionado: gabarito.tipo })
    }


    listarGanhadores = async (e) => {
        console.log(JSON.parse(localStorage.getItem("user"))._id)
        try {
            var axiosInstance = new Axios.create({
                baseURL: window.localStorage.getItem("apiUrl")
            });
            const response = await axiosInstance.post("/gabaritos/ganhadores-gerente", { gerenteId: JSON.parse(localStorage.getItem("user"))._id });
            this.setState({ gabaritos: response.data });
            console.log(response.data)

        } catch (err) {
            console.log(err);
        }
    };


    async getClientesPorCambista(item) {
        this.setState({ cartelaSelecionada: item })
        try {
            const response = await API.post("/api/usuarios/listar-por-tutor", {
                tutorId: item.cambistaId._id
            });
            this.setState({ clientes: response.data.sort(this.compararNome) });
        } catch (err) {
            console.log(err);
        }
    };

    compararNome(a, b) {
        if (a.nome.toLowerCase() > b.nome.toLowerCase()) {
            return 1;
        }
        if (a.nome.toLowerCase() < b.nome.toLowerCase()) {
            return -1;
        }

        return 0
    }

    resetForm = () => {

        this.setState({
            form: {nome : "", telefone: "", cidade: "", estado: "" }
        })
    }


    setCliente(e) {
        this.state.clienteSelecionado = JSON.parse(e.target.value);
        this.setState({ clienteSelecionado: JSON.parse(e.target.value) })
    }

    async salvarPedidoEditado() {
        this.state.cartelaSelecionada.ganhadorId = this.state.clienteSelecionado._id;
        this.state.cartelaSelecionada.cambistaId = this.state.clienteSelecionado.tutorId;
        if (this.state.clienteSelecionado) {
            try {
                const response = await API.post("/api/gabaritos/update-gabarito", {
                    ...this.state.cartelaSelecionada
                });
                alert("Salvo com sucesso!")
                window.location.reload()
            } catch (err) {
                console.log(err);
            }
        }
    }

    cadastrarCliente = async (e) => {
        if(this.state.form.nome.length < 3 || this.state.form.telefone.length < 11 || this.state.form.nome.cidade < 3 || this.state.form.estado.length < 1 ){
            alert("As informações inseridas não são válidas!")
            return;
        }
        else{
            try {
                const dados = {
                    ...this.state.form,
                    tutorId: this.state.cartelaSelecionada.cambistaId._id
                }
                const response = await API.post('/api/usuarios/fast', dados);
                if(response){
                    alert("Cadastrado com sucesso!")
                    this.resetForm();
                    window.location.reload();
                }
            } catch (error) {
                console.log(error)
                alert("Algo deu errado!");
            }
        }
    }

    handleChangeCadastroRapido(e){
    
        if(e.target.name == "telefone"){
            
            this.state.form.telefone = e.target.value;
            this.setState({form : this.state.form})
            if(!e.target.value.match(/\d/)){
                e.target.value = '';
                this.state.form.telefone = e.target.value;
                this.setState({form : this.state.form})
            }
            if(e.target.value.length > 10){
                let p = e.target.value;
                e.target.value = `${p[0]}${p[1]} ${p[2]}${p[3]}${p[4]}${p[5]}${p[6]} ${p[7]}${p[8]}${p[9]}${p[10]}`
                this.state.form.telefone = e.target.value;
                this.setState({form : this.state.form})
            }
        }
        else{
            this.state.form[e.target.name] = e.target.value;
            this.setState({form : this.state.form});
        }
    }

    render() {
        return (
            <GerenteTemplate label={'Ganhadores'}>
           <div className="modal fade" id="modalCadastroRapido" tabIndex="-1" role="dialog" aria-labelledby="modalCadastroRapidoTitle" aria-hidden="true" style={{zIndex: 3002}}>
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header pb-3">
                                <h5 className="modal-title font-weight-bold" id="modalCadastroRapidoTitle">Cadastro
                                                                                                                                                                                                      rápido de clientes</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body"
                                style={
                                    {
                                        borderTop: '1px solid #e9ecef',
                                        borderBottom: '1px solid #e9ecef'
                                    }
                            }>
                                <form>
                                    <div className="form-row">
                                        <div className="form-group col">
                                            <input type="text" name="nome"
                                                className={
                                                    `form-control`
                                                }
                                                id="nome"
                                                placeholder="Nome completo"
                                                value={
                                                    this.state.form.nome || ''
                                                }
                                                onChange={
                                                    this.handleChangeCadastroRapido.bind(this)
                                                }/>
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <div className="form-group col-lg-6">
                                            <input name="telefone" type="text" placeholder="Telefone"
                                                className={`form-control`}
                                                maxLength={11}
                                                value={this.state.form.telefone || ''}
                                                onChange={this.handleChangeCadastroRapido.bind(this) }/>
                                        </div>
                                        <div className="form-row">
                                            <div className="form-group col">
                                                <input type="text" name="cidade"
                                                    className={
                                                        `form-control`
                                                    }
                                                    id="cidade"
                                                    placeholder="Cidade"
                                                    value={
                                                        this.state.form.cidade || ''
                                                    }
                                                    onChange={
                                                        this.handleChangeCadastroRapido.bind(this)
                                                    }/>
                                            </div>
                                        </div>
                                        <div className="form-row pl-4">
                                            <div className="form-group col">
                                                <input type="text" name="estado"
                                                    className={
                                                        `form-control`
                                                    }
                                                    id="estado"
                                                    placeholder="Estado"
                                                    value={
                                                        this.state.form.estado || ''
                                                    }
                                                    onChange={
                                                        this.handleChangeCadastroRapido.bind(this)
                                                    }/>
                                            </div>
                                        </div>

                                    </div>
                                </form>
                            </div>
                            <div className="modal-footer d-flex justify-content-end pt-3">
                                <button type="button" className="btn btn-fill btn-secondary mr-1" data-dismiss="modal">Cancelar
                                </button>
                                <button type="button"
                                    onClick={
                                        this.cadastrarCliente.bind(this)
                                    }
                                    className="btn btn-fill btn-success">Salvar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal fade" id="exampleModalCenter2" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" style={{ maxWidth: '50vw' }} role="document">
                        <div class="modal-content "  >
                            <div class="modal-header">
                                <h4 class="modal-title font-weight-bolder" id="exampleModalLongTitle">Editar o cliente do pedido</h4>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close" >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                            <div className="d-flex">
                                    <button type="button"
                                        title={'Cadastro rápido'}
                                        className="btn btn-primary btn-fill btn-icon float-md-right ml-3 mr-md-1"
                                        data-toggle="modal"
                                        onClick={
                                            this.resetForm
                                        }
                                        data-target="#modalCadastroRapido">
                                        <i className="fas fa-rocket"></i>
                                        Cadastrar cliente
                                    </button>
                                </div>       
                                <h4>Procure o cliente correto</h4>
                                <select onChange={this.setCliente.bind(this)} style={{ zIndex: '3000' }} class="ml-1 custom-select">
                                    <option value={JSON.stringify(null)} selected>Selecione um cliente</option>
                                    {this.state.clientes.length > 0 ? this.state.clientes.map(cliente => {
                                        return <option value={JSON.stringify(cliente)}>{cliente.nome} - {cliente.telefone}</option>
                                    }) : ""}
                                </select>
                                                                                                              
                            </div>
                            <div class="modal-footer" style={{ justifyContent: 'flex-end' }}>
                                <button className="btn btn-fill btn-success" onClick={this.salvarPedidoEditado.bind(this)}>Salvar</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal fade" id="exampleModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content" style={{ marginTop: '-5em' }}>
                            <div class="modal-header">
                                <h5 class="modal-title" id="exampleModalLabel">Detalhes da cartela</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            {this.state.cartelaSelecionada ?

                                <div class="modal-body justify-content-center">
                                    <Cartela class="ml-3" conferir={this.state.tipoSelecionado} cartela={this.state.cartelaSelecionada}></Cartela>
                                </div>
                                : ""}

                            <div class="modal-footer">
                                <button data-dismiss="modal" aria-label="Close" data-toggle="modal" data-target="#staticBackdrop" type="button" class="btn-fill btn btn-primary">Voltar</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card strpied-tabled-with-hover">
                                <div className="card-header ">
                                    <h4 className="card-title">
                                        Todos os ganhadores da semana
                                    </h4>
                                    <p className="card-category">
                                        Informações dos premios da rodada.
                                    </p>
                                </div>
                                <div className="card-body table-full-width table-responsive">
                                    <table className="table table-hover table-striped">
                                        <thead>
                                            <tr>
                                                {/* <th>Data</th> */}
                                                <th>Tipo de batida</th>
                                                <th>Cartela</th>
                                                <th>Ganhador</th>
                                                <th>Telefone</th>
                                                <th>Endereço</th>
                                                <th>Vendedor</th>
                                                <th>Preview</th>
                                                <th>Editar</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.gabaritos.length > 0
                                                ? this.state.gabaritos.map((item) => {
                                                    return (
                                                        <tr>
                                                            {/* <td>{this.formatDate(item.data)}</td> */}
                                                            <td>{item.tipo}</td>
                                                            <td>{item.cartelaSorteada.codigo}</td>
                                                            <td>{item.ganhadorId ? item.ganhadorId.nome : "Desconhecido"}</td>
                                                            <td>{item.ganhadorId ? item.ganhadorId.telefone : "Desconhecido"}</td>
                                                            <td>{item.ganhadorId.endereco} - {item.ganhadorId.bairro} - {item.ganhadorId.cidade} - {item.ganhadorId.estado}</td>
                                                            <td>{item.cambistaId ? item.cambistaId.nome : "Desconhecido"}</td>
                                                            <td><button onClick={this.selecionarCartela} accessKey={JSON.stringify(item)} class="btn-fill btn btn-success" data-toggle="modal" data-dismiss="modal" data-target="#exampleModal" >Preview</button></td>
                                                            <td><button className="btn mt-4" data-toggle="modal" data-target="#exampleModalCenter2" onClick={() => this.getClientesPorCambista(item)} >Editar</button></td>
                                                        </tr>
                                                    );
                                                })
                                                : ""}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </GerenteTemplate>
        );
    }
}

export default GanhadoresGerente;
